/**
 * TrackFlow runs in two modes from one bundle:
 *   standalone — trackflow's own pages, cookie sessions (/, /login, /dashboard, /t/…)
 *   embedded   — inside Shopify admin, under /shopify/*, authenticated with App Bridge ID tokens
 */
export const EMBEDDED_BASE = '/shopify';

export function isEmbedded(): boolean {
  return (
    typeof window !== 'undefined' &&
    (window.location.pathname === EMBEDDED_BASE ||
      window.location.pathname.startsWith(`${EMBEDDED_BASE}/`))
  );
}

interface AppBridge {
  idToken(): Promise<string>;
  toast?: { show(message: string, opts?: { isError?: boolean; duration?: number }): void };
}

declare global {
  interface Window {
    shopify?: AppBridge;
  }
}

/** A fresh ID token for each request (they expire after about a minute; never cache them). */
export async function shopifyIdToken(): Promise<string | null> {
  if (!window.shopify?.idToken) return null;
  try {
    return await window.shopify.idToken();
  } catch {
    return null;
  }
}

/**
 * Leave the iframe for pages Shopify doesn't allow framed (e.g. the charge-approval screen).
 * Relative in-app URLs stay in the iframe.
 */
export function openTopLevel(url: string) {
  if (isEmbedded()) window.open(url, '_top');
  else window.location.assign(url);
}
